import { render, staticRenderFns } from "./listaestudante.vue?vue&type=template&id=269149be&"
import script from "./listaestudante.vue?vue&type=script&lang=js&"
export * from "./listaestudante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports